import { jsx as _jsx } from "react/jsx-runtime";
import { Container, useMediaQuery } from '@mui/material';
import PageSection from '../components/sections/PageSection';
import MapSection from '../components/sections/MapSection';
import theme from '../Theming/DefaultTheme';
import PageWrapper from '../components/wrappers/PageWrapper';
var Home = function () {
    var isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    var pageContainerStyle = {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: isMobile ? 0 : 24,
        padding: 0,
    };
    return (_jsx(PageWrapper, { children: _jsx(Container, { style: pageContainerStyle, maxWidth: false, children: _jsx(PageSection, { sectionId: 'home', children: _jsx(MapSection, {}) }) }) }));
};
export default Home;
